import { Checkbox, Col, Input, Row, Space, message } from "antd";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FAN } from "../../../helpers/constant";
import { authService } from "../../../services";
import { APP_DOMAIN, I18NEXT_LANGUAGE_KEY } from "../../../utls/constants";
import { capitalizeFirstLetter } from "../../../utls/FunctionsUtil";
import AuthButtonComponent from "../../AuthButtonCompnent";
import InputComponent from "../../InputComponent";
import SpinnerComponent from "../../SpinnerComponent/SpinnerComponent";
import "../index.less";

interface PublicRegisterViewComponentProps {
  onClose: () => void;
  isFightEvent?: boolean;
}

const PublicRegisterViewComponent: React.FC<PublicRegisterViewComponentProps> = ({ onClose, isFightEvent }) => {
  const { t } = useTranslation();
  const [data, setData] = useState<{ [key: string]: string }>({});
  const [acceptAuthTerms, setAcceptAuthTerms] = useState<boolean>(true);
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [fieldErrors, setFieldErrors] = useState<{
    username?: boolean;
    email?: boolean;
  }>({});

  const handleFocus = () => {
    setIsKeyboardOpen(true);
  };

  const handleBlur = () => {
    setIsKeyboardOpen(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));

    if (fieldErrors[name as keyof typeof fieldErrors]) {
      setFieldErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const register = () => {
    setFieldErrors({});

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const isEmail = emailRegex.test(data.email || "");
    if (!data.firstName) return message.warning(t("first-name-required"));
    if (!data.lastName) return message.warning(t("last-name-required"));
    if (!data.username || data.username.length < 3) return message.warning(t("username-required"));
    if (!data.email || !isEmail) {
      setFieldErrors((prev) => ({ ...prev, email: true }));
      return message.warning(t("invalid-email"));
    }
    if (!data.password || data.password.length < 6) return message.warning(t("password-required"));
    if (!acceptAuthTerms) return message.warning(t("terms-conditions-error-message"));

    setIsLoading(true);

    authService
      .register({
        ...data,
        firstName: capitalizeFirstLetter(data.firstName),
        lastName: capitalizeFirstLetter(data.lastName),
        username: data.username.toLowerCase(),
        type: FAN,
        lang: localStorage.getItem(I18NEXT_LANGUAGE_KEY),
      })
      .then(() => {
        onClose();
        if (isFightEvent) {
          localStorage.setItem("redirectToEvent", "common/event-payment?fln=rtlf");
        }
        Cookies.set("ffe", "flp");
        window.location.reload();
      })
      .catch((error) => {
        if (error === "username-has-been-taken") {
          setFieldErrors({ username: true });
          message.error(t("username-has-been-taken"));
        } else if (error === "email-has-been-taken") {
          setFieldErrors({ email: true });
          message.error(t("email-has-been-taken"));
        } else {
          message.error(t(error));
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className={`register-view ${isKeyboardOpen ? "keyboard-open" : ""} ${isLoading ? "center-loader" : ""}`}>
      {isLoading ? (
        <div className="mt-50">
          <SpinnerComponent />
        </div>
      ) : (
        <Col className="w-full">
          <Row gutter={11}>
            <Col span={12}>
              <Input
                className="public-register-custom-input"
                placeholder={t("first-name-label")!}
                type="text"
                name="firstName"
                value={data.firstName || ""}
                onChange={handleChange}
              />
            </Col>
            <Col span={12}>
              <Input
                className="public-register-custom-input"
                placeholder={t("last-name-label")!}
                type="text"
                name="lastName"
                value={data.lastName || ""}
                onChange={handleChange}
              />
            </Col>
          </Row>
          <Row className="mt-16">
            <Input
              className={`public-register-custom-input ${fieldErrors.username ? "input-error" : ""}`}
              placeholder={t("user-name-label")!}
              type="text"
              name="username"
              value={data.username || ""}
              onChange={handleChange}
            />
          </Row>
          <Row className="mt-16">
            <Input
              className={`public-register-custom-input ${fieldErrors.email ? "input-error" : ""}`}
              placeholder={t("email-label")!}
              type="email"
              name="email"
              value={data.email || ""}
              onChange={handleChange}
            />
          </Row>
          <Row className="mt-16">
            <Space className="w-full gap-6" direction="vertical">
              <InputComponent
                className="public-register-custom-input"
                placeholder={t("password-label")!}
                name="password"
                onChange={handleChange}
                value={data.password || ""}
                type="password"
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
            </Space>
          </Row>
          <Row>
            <Checkbox className="mt-10 authTermsCheckBox" checked={acceptAuthTerms} onChange={(e) => setAcceptAuthTerms(e.target.checked)}>
              <span>{t("auth-terms-1")}</span>
              <span className="text-color-green">{t("auth-terms-2")}</span>
              <span>{t("auth-terms-3")}</span>
              <a href={`https://${APP_DOMAIN}/conditions-generales-de-vente/`} target="_blank" rel="noopener noreferrer">
                {t("terms-and-conditions")}
              </a>
              {t("and")}
              <a href={`https://${APP_DOMAIN}/confidentialite-et-protection-des-donnees/`} target="_blank" rel="noopener noreferrer">
                {t("privacy-policy")}
              </a>
            </Checkbox>
          </Row>
          <Row className="mt-25 mb-10">
            <AuthButtonComponent label={t("auth-signUp-button")} onClick={register} />
          </Row>
        </Col>
      )}
    </div>
  );
};

export default PublicRegisterViewComponent;
